/**
 * @deprecated
 */
import $ from 'jquery';
import './web/jquery.faq';
// require('../../../../node_modules/svg4everybody/');

// svg4everybody();

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}

/**
 * Prepending URL to the anchors.
 * https://www.tiny.cloud/docs/plugins/anchor/#anchorpluginexample
 * https://www.tiny.cloud/docs/plugins/link/
 * TODO - MAL - youtube.com/watch?v=3v17JZ9erb4 native behaviour. MFR to prepare anchor selector to the context menu of the link selection.
 */
// select all links
let tinyMceAnchors = document.querySelectorAll('.wysiwyg-content a');

// loop through
for (let i = 0; i < tinyMceAnchors.length; i++) {
	// find if any has an id
	if (tinyMceAnchors[i].id) {
		const anchId = tinyMceAnchors[i].id;
		// if it does find first one and prepend URL
		let corrLinks = document.querySelectorAll('.wysiwyg-content a[href="#' + anchId + '"]');
		// prepend URL to corresponding links
		for (let i = 0; i < corrLinks.length; i++) {
			corrLinks[i].href = window.location.pathname + '#' + anchId;
		}
	}
}

/**
 * URL checker
 * This is to check if the link has target blank,
 * if not and the url is not uhk native, add target blank.
 */

for (var links = document.links, i = 0, a; a = links[i]; i++) {
	if (a.target !== '_blank' && a.host !== location.host && !a.href.includes('javascript')) {
		a.target = '_blank';
		a.rel = 'noopener';
	}
}


/**
 * Sticky Menu
 */

window.addEventListener("scroll", function () {
	showToTopLink();
	const fulltextDropdown = document.getElementById('js_fulltextDropdown');
	const navbar = document.getElementById("headerMain");

	if (!fulltextDropdown.classList.contains('opened')) {
		if (window.pageYOffset > 100) {
			document.body.style.paddingTop = 40 + 'px';
			navbar.classList.add("sticky");
			navbar.parentElement.classList.add("sticky-bg");
		}
		if (window.pageYOffset <= 100) {
			navbar.classList.remove("sticky");
			navbar.parentElement.classList.remove("sticky-bg");
			document.body.style.paddingTop = 0 + 'px';
		}
	}
});


/**
 * Odscrollování na kotvu pokud je sticky menu
 */
$(document).on('click', 'a', function () {
	var topOffset = 120;
	var href = $(this).attr("href");
	var targetElement = href.substr(href.indexOf("#")).substr(1);

	if (window.pageYOffset > 100) {
		topOffset = 100;
	}

	if (targetElement !== '' && targetElement !== null && $('#' + targetElement).length) {
		$('html, body').animate({
			scrollTop: parseInt($('#' + targetElement).offset().top - topOffset)
		}, 150, 'linear');
	}
});


/**
 * Floating Labels
 */
let inputs = document.querySelectorAll('.form-group input:not([type=radio]):not([type=checkbox]):not([disabled])');
let textareas = document.querySelectorAll('textarea');
var selects = document.querySelectorAll('select');
let disabled = document.querySelectorAll('*[disabled]');
var required = document.querySelectorAll('*[required], *[data-required]');
let espTrigger = document.querySelectorAll('.js_esp-trigger');


/**
 *  check if input element has value, add/remove classes accordingly
 *  */
const initLabels = function (element) {
	let fG = element.closest('.form-group:not(.category-filter__group):not(.course-program__form-fulltext-group)');

	if (fG) {
		if (element.value === "" && !element.disabled) {
			fG.classList.add('form-group--label-hidden');
			fG.classList.remove('form-group--label-visible');
		} else {
			fG.classList.add('form-group--label-visible');
			fG.classList.remove('form-group--label-hidden');
		}
		// back fix for file inputs - labels always visible
		if (element.type === 'file') {
			fG.classList.remove('form-group--label-hidden');
			fG.classList.add('form-group--label-visible');
			fG.classList.add('file-input');
		}
	}
};

const typeHandler = function (e) {
	let fG = this.closest('.form-group:not(.course-program__form-fulltext-group)');
	if (fG) {
		if (this.value === "") {
			fG.classList.add('form-group--label-hidden');
			fG.classList.remove('form-group--label-visible')
		} else {
			fG.classList.add('form-group--label-visible');
			fG.classList.remove('form-group--label-hidden');
		}
	}
};

/*
for (let i = 0; i < inputs.length; i++) {
	initLabels(inputs[i]);
	// when you type register for oninput
	inputs[i].addEventListener('input', typeHandler);
	// for IE8
	inputs[i].addEventListener('propertychange', typeHandler);
	// fallback for Firefox for <select><option>, for <input> oninput is enough
	// inputs[i].addEventListener('change', typeHandler)
}


for (let i = 0; i < textareas.length; i++) {
	initLabels(textareas[i]);
	textareas[i].addEventListener('input', typeHandler);
	textareas[i].addEventListener('propertychange', typeHandler);
}

for (let i = 0; i < selects.length; i++) {
	initLabels(selects[i]);
	selects[i].addEventListener('input', typeHandler);
	selects[i].addEventListener('propertychange', typeHandler);
}

for (let i = 0; i < disabled.length; i++) {
	initLabels(disabled[i]);
}
*/

// for (let i = 0; i < espTrigger.length; i++) {
//
// 	espTrigger[i].addEventListener('click', function () {
// 		/**
// 		 * set timeot to make sure esp target content is found and form elements can be reinitiated
// 		 */
// 		setTimeout(function () {
// 			let popupInputs = document.querySelectorAll('.esp-target form input.form-control');
// 			let popuptextareas = document.querySelectorAll('.esp-target form textarea.form-control');
// 			let popupselects = document.querySelectorAll('.esp-target form select.form-control');
// 			/**
// 			 * reinit form elements in popup;
// 			 */
// 			for (let i = 0; i < popupInputs.length; i++) {
// 				initLabels(popupInputs[i]);
// 				popupInputs[i].addEventListener('input', typeHandler);
// 				popupInputs[i].addEventListener('propertychange', typeHandler);
// 			}
//
// 			for (let i = 0; i < popuptextareas.length; i++) {
// 				initLabels(popuptextareas[i]);
// 				popuptextareas[i].addEventListener('input', typeHandler);
// 				popuptextareas[i].addEventListener('propertychange', typeHandler);
// 			}
//
// 			for (let i = 0; i < popupselects.length; i++) {
// 				initLabels(popupselects[i]);
// 				popupselects[i].addEventListener('input', typeHandler);
// 				popupselects[i].addEventListener('propertychange', typeHandler);
// 			}
//
// 			const submit = document.querySelector('.esp-target form button[type=submit]');
// 			submit.addEventListener('click', function(e) {
// 				console.log('click');
// 				$('.esp-fixed-container').animate({ scrollTop: 0 }, 200);
// 			});
// 		}, 500);
// 	});
// }


/**
 * to Top JS
 * @type {Element}
 */

let toTop = document.getElementsByClassName("js_toTop")[0];

// When the user scrolls down 120px from the top of the document, show the button
function showToTopLink() {
	if (toTop) {
		if (document.body.scrollTop > 120 || document.documentElement.scrollTop > 120) {
			toTop.classList.add("active");
		} else {
			toTop.classList.remove("active");
		}
	}
}


/**
 * Badger Accordion
 */

import BadgerAccordion from 'badger-accordion';

const accordions = document.querySelectorAll('.js-badger-accordion');

Array.from(accordions).forEach((accordion) => {
	const ba = new BadgerAccordion(accordion);
});

/**
 * Citation
 */
window.addEventListener('resize', fitCitation, true);
fitCitation();
function fitCitation() {
	document.querySelectorAll('.citation__text-inner').forEach(function(text) {
		text.style.display = 'inline';
		text.style.width = 'auto';
		text.style.width = (text.offsetWidth + 1) + 'px';
		text.style.display = 'inline-block';
	});
}
/**
 * Color anchors
 */
$(document).on('ajaxComplete', function(){
	colorAnchors();
});
colorAnchors();
function colorAnchors() {
	document.querySelectorAll('.color-fim, .color-ff, .color-uhk, .color-pdf, .color-prf').forEach(function (item) {
		if (item.querySelector('a')) {
			item.classList.add('color-has-anchor');
		}
	});
}

/**
 * Skip to submenu
 */
const skipItemSubmenu = document.querySelector('.skip__item--submenu');
if (skipItemSubmenu && document.querySelectorAll('nav.side-menu').length === 0 && document.querySelectorAll('nav.column-links').length === 0) {
  skipItemSubmenu.remove();
}
const firstHeader = document.querySelectorAll('h1:not(.header__logo)')[0];
if (firstHeader) {
	firstHeader.setAttribute('id','mainContent');
}

/**
 * Quick links - forum
 */
const quickLinksForum = document.querySelectorAll('.js_private-link-forum');
if (document.querySelector('.registration-links__label--logged') && document.querySelector('.registration-links__label--logged').dataset.user.includes('FORUM_ACCESS') && quickLinksForum.length) {
  quickLinksForum.forEach(function(quickLinkForum) {
    quickLinkForum.classList.remove('private-link-forum--locked');
    quickLinkForum.querySelector('.private-link').classList.remove('private-link--locked');
    quickLinkForum.querySelector('.private-link').classList.add('private-link--unlocked');
  });
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js